import React from 'react';
import PropTypes from 'prop-types';
import { Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';

import { cdnURL } from 'components/utils/cdn';

import { useIsMobile } from 'hooks/app';

import './styles.scss';

const AiMessagePromo = ({ className }) => {
  const navigate = useNavigate();
  const isMobile = useIsMobile(['XXXS', 'XXS', 'XS']);
  return (
    <div className={`ai-message-promo-container ${className}`}>
      <div className="ai-message-promo-contents">
        <p className="ai-message-promo-pretitle">NEW FEATURE</p>
        <h2 className="ai-message-promo-title">Effortless Messages with AI Magic!</h2>
        <p className="ai-message-promo-subtitle">Struggling to find the right words? Our new AI-powered tool helps you craft personalized, heartfelt messages for any occasion in seconds.</p>
        <div>
          <Button onClick={() => navigate('/cards/birthday-wishes')}>{isMobile ? 'TRY IT NOW' : 'TRY MESSAGE GENERATION NOW'}</Button>
        </div>
      </div>
      <div className="ai-message-promo-video">
        <video
          src={cdnURL('img/rebuild/promote/ai-message/generate-2.mp4')}
          width={653}
          height={415}
          loop
          muted
          autoPlay
          playsInline
        />
      </div>
    </div>
  );
}


AiMessagePromo.propTypes = {
  className: PropTypes.string,
};

AiMessagePromo.defaultProps = {
  className: ''
};

export default AiMessagePromo;
